import React from 'react';
import { Icon } from '@iconify/react';
import starFill from '@iconify/icons-eva/star-fill';
import { SvgIcon } from '@material-ui/core'; // ----------------------------------------------------------------------

var ICON_SMALL = {
  width: 20,
  height: 20
};
var ICON_LARGE = {
  width: 28,
  height: 28
};
var ICON = React.createElement(SvgIcon, null, React.createElement(Icon, {
  icon: starFill
}));
export var Rating = function Rating(_ref) {
  var theme = _ref.theme;
  return {
    MuiRating: {
      defaultProps: {
        emptyIcon: ICON,
        icon: ICON
      },
      styleOverrides: {
        root: {
          '&$disabled': {
            opacity: 0.48
          }
        },
        iconEmpty: {
          color: theme.palette.grey[50048]
        },
        sizeSmall: {
          '& svg': Object.assign({}, ICON_SMALL)
        },
        sizeLarge: {
          '& svg': Object.assign({}, ICON_LARGE)
        }
      }
    }
  };
};